import React, { Component, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button,
  Popconfirm,
} from 'antd';
import Add from '@Images/admin/add.png';
import Success from '@Images/admin/success.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import { SettingOutlined,DeleteOutlined } from '@ant-design/icons';

/**
 *
 */
const ZohoConnectionList = ({
  getZohoConnectionsLoading, history, zohoConnections, updateZohoConnectionLoading, updateZohoConnection, getZohoConnections, user,deleteZohoConnectionLoading,deleteZohoConnection,setIsUserAllReadyConnected
}) => (
  <div className="zoho-list-wrapper">
    {
      !getZohoConnectionsLoading && zohoConnections ? (
        <React.Fragment>
          {zohoConnections.map((item) => (
            <React.Fragment key={item?.iz_id}>
              <div className={`zoho-card ${(item?.is_active === false && zohoConnections?.find((rec) => rec.is_active)) ? 'zoho-card-inactive' : ''}`}>
                <div className="zoho-card-spacing">
                  <div className="zoho-card-header">
                    <p>
                      {item?.organisation_info?.name}
                    </p>
                    {item?.is_active && <img src={Success} alt="" className="zoho-card-header__img" />}
                  </div>
                  <H3Text text={`${item?.branches?.length || '0'} Branches in ${item?.organisation_info?.country}`} className="zoho-card-link" />
                  <div className="zoho-card-link" />
                  <div className="zoho-card-footer">
                    <div className="flex text-gray">
                      {item?.is_active ? (
                        <React.Fragment>
                          <div
                            className="zoho-card-footer__link"
                            onClick={() => {
                              history.push('/admin/integration/zoho/setup');
                            }}
                          >
                            <SettingOutlined />
                            &nbsp;
                            Edit Configuration
                          </div>
                          <Popconfirm
                          placement='topRight'
                          title="Are you sure you want to delete this configuration?"
                          onConfirm={() => deleteZohoConnection(
                            { 
                              iz_id : item?.iz_id ,
                              org_id : user?.tenant_info?.org_id 
                            },
                            () => setIsUserAllReadyConnected(false),
                          )}
                          okText="Delete"
                          okButtonProps={{
                            loading: deleteZohoConnectionLoading,
                          }}
                          cancelText="Cancel"
                          style={{
                            width: '200px',
                          }}
                          >
                          <div className="deleteButton">
                            <DeleteOutlined />
                          </div>
                          </Popconfirm>
                        </React.Fragment>
                      ) : (
                        <div />
                      )}
                      {!item?.is_active && (
                        <Popconfirm
                          placement="topRight"
                          title="Switching to a different organisation can impact for Vendor Payables data on Zoho Books. Are your sure you want continue?"
                          onConfirm={() => updateZohoConnection(
                            {
                              iz_id: item?.iz_id,
                              is_active: true,
                            },
                            () => getZohoConnections(user?.tenant_info?.org_id),
                          )}
                          okText="Activate"
                          okButtonProps={{
                            loading: updateZohoConnectionLoading,
                          }}
                          cancelText="Cancel"
                          style={{
                            width: '200px',
                          }}
                        >
                          <Button
                            loading={updateZohoConnectionLoading}
                            disabled={updateZohoConnectionLoading}
                            className="zoho__activate-btn"
                          >
                            Set as Default
                          </Button>
                        </Popconfirm>
                      )}
                      {/* </div> */}
                    </div>
                  </div>

                </div>
              </div>
            </React.Fragment>
          ))}
        </React.Fragment>
      ) : (
        <div
          className="zoho-list-wrapper"
        >
          <div
            className="loading-zoho__card  "
          >
            <div className="zoho-card-spacing">

              <div className="zoho-card-header ">

                <div className="loadingBlock loading-zoho-header__text" />
                <div className="loadingBlock loading-zoho-header__image"> </div>
              </div>

              <div className="loadingBlock loading-zoho-card__link"> </div>
              <div className="zoho-card-footer">
                <div
                  className="flex "
                >

                  <p className="loadingBlock loading-zoho-card__footer" />
                </div>
              </div>
            </div>
          </div>

        </div>
      )

    }

  </div>
);

const mapStateToProps = ({ UserReducers, ZohoIntegrationReducers }) => ({
  user: UserReducers.user,
  zohoConnections: ZohoIntegrationReducers.zohoConnections,
  updateZohoConnectionLoading: ZohoIntegrationReducers.updateZohoConnectionLoading,
  deleteZohoConnectionLoading: ZohoIntegrationReducers.deleteZohoConnectionLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateZohoConnection: (payload, callback) => dispatch(ZohoIntegrationActions.updateZohoConnection(payload, callback)),
  getZohoConnections: (orgId, callback) => dispatch(ZohoIntegrationActions.getZohoConnections(orgId, callback)),
  deleteZohoConnection: (payload, callback) => dispatch(ZohoIntegrationActions.deleteZohoConnection(payload, callback)),
});
ZohoConnectionList.propTypes = {
  user: PropTypes.any,
  zohoConnections: PropTypes.any,
  getZohoConnectionsLoading: PropTypes.bool,
  updateZohoConnectionLoading: PropTypes.bool,
  history: PropTypes.any,
  updateZohoConnection: PropTypes.bool,
  getZohoConnections: PropTypes.func,
  deleteZohoConnectionLoading : PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ZohoConnectionList));
